<template>
    <div>
        <div class="panel-body">
            <div class="form-group">
                <textarea id="outputTextArea" class="form-control" :value="phoneticOutput.text"></textarea>
            </div>
            <div style="text-align: center;">
                <button type="button" class="btn btn-success btn-lg" @click="copyToClipboard">
                    Copy to clipboard
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
    name: 'PhoneticOutput',
    computed: {
        ...mapGetters({
            phoneticOutput: 'phoneticOutput'
        })
    },

    methods: {
        copyToClipboard () {
            let selector = document.getElementById('outputTextArea');
            selector.select();
            document.execCommand('copy');
        }
    }

};
</script>
